import { GTM, GTM_EVENTS } from '../gtm/gtm-events'

const actions = {
  [GTM]: {
    [GTM_EVENTS.gtmEcomPromotionView]: ({ promotions }) => {
      return {
        ecommerce: {
          promoView: {
            promotions,
          },
        },
      }
    },
  },
}
export default actions
